<div class="d-flex flex-column">
    <div class="d-flex flex-column g-8">

        <em *ngIf="czyWyswietlicSeparator" class="separator"></em>

        <div *ngIf="czyPrzedmiotZUszkodzeniem()" class="d-flex flex-column g-20">
            <div class="subject-box">
                <div class="subject-wrapper float-left">
                    <em class="c-icon c-icon--{{przedmiot.imageSource}} u-icon--big"></em>
                    <div class="subject">
                        <span class="label">Przedmiot zgłoszenia:</span>
                        <span class="name">{{ przedmiot.label }}</span>
                    </div>
                </div>
                <div class="btn-group">
                    <div *ngIf="!czyDodaneUszkodzenia()" class="damage-button-group">
                        <div *ngIf="czyMoznaDodacKolejneUszkodzenie()" class="dmg-btn" (click)="wybierzPrzedmiotUbezpieczenia(przedmiot)">
                            <span>Dodaj uszkodzenie</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="zbiorUszkodzenPrzedmiotu">
            <ng-container *ngFor="let zbiorUszkodzenId of pobierzPosortowaneDodaneUszkodzenia()">
                <app-zbior-uszkodzen
                        [zbiorUszkodzenPrzedmiotuId]="zbiorUszkodzenPrzedmiotu.id"
                        [zbiorUszkodzen]="(pobierzZbiorUszkodzen(zbiorUszkodzenId) | async) ?? {}"
                        (usunZbiorUszkodzenClick)="usunZbiorUszkodzen($event)"
                        (usunUszkodzenieClick)="usunUszkodzenie($event)"
                        [czyPrzedmiotZUszkodzeniem]="czyPrzedmiotZUszkodzeniem()">
                </app-zbior-uszkodzen>
            </ng-container>
        </ng-container>
    </div>

    <div #buttonElement *ngIf="czyDodaneUszkodzenia() && czyPrzedmiotZUszkodzeniem()" class="damage-button-group {{czyMoznaDodacKolejneUszkodzenie() ? 'mt-8' : ''}}">
        <div *ngIf="czyMoznaDodacKolejneUszkodzenie() && czyDodaneUszkodzenia() && !czyDodaneDodatkowePrace" class="rep-btn" (click)="dodajDodatkowePrace()">
            <span>Dodatkowe prace naprawcze</span>
        </div>
        <div *ngIf="czyMoznaDodacKolejneUszkodzenie()" class="dmg-btn" (click)="wybierzPrzedmiotUbezpieczenia(przedmiot)">
            <span>Dodaj uszkodzenie</span>
        </div>
    </div>

    <div *ngIf="sprawdzCzyPoprawnaWalidacja()" class="validation-message">
        <span>Dodaj uszkodzenia, aby obliczyć szacunkową kwotę odszkodowania.</span>
    </div>

</div>
